<template>
  <div>
    <melon-t-v-banner />
    <div class="contents contents--pt _pb-md">
      <section class="section--pt-xlg">
        <div class="inner">
          <ul class="Pagelink">
            <li class="Pagelink__item">
              <a @click="scrollMeTo('effects')">効果と継続</a>
            </li>
            <li class="Pagelink__item">
              <a @click="scrollMeTo('tutorial')">利用方法とコツ</a>
            </li>
            <li class="Pagelink__item">
              <a @click="scrollMeTo('online')">クラスの選び方</a>
            </li>
            <li class="Pagelink__item">
              <a @click="scrollMeTo('trial')">トライアルクラス</a>
            </li>
            <li class="Pagelink__item">
              <a @click="scrollMeTo('whats')">理論を学ぶ</a>
            </li>
          </ul>
        </div>
      </section>
      <mindfulness />
      <effects ref="effects" />
      <tutorial ref="tutorial" />
      <melon-online-class ref="online" />
      <trial-class ref="trial" />
      <mindfulness-class ref="whats" />
    </div>
  </div>
</template>
<script>
import MelonTVBanner from '@/views/pages/beginner/components/MelonTVBanner'
import Mindfulness from '@/views/pages/beginner/components/Mindfulness'
import Effects from '@/views/pages/beginner/components/Effects'
import Tutorial from '@/views/pages/beginner/components/Tutorial'
import MelonOnlineClass from '@/views/pages/beginner/components/MelonOnlineClass'
import TrialClass from '@/views/pages/beginner/components/TrialClass'
import MindfulnessClass from '@/views/pages/beginner/components/MindfulnessClass'

export default {
  name: 'Beginner',
  components: { MelonTVBanner, Mindfulness, Effects, Tutorial, MelonOnlineClass, TrialClass, MindfulnessClass },
  data() {
    return {
      abc: 0
    }
  },
  methods: {
    scrollMeTo(refName) {
      var element = document.getElementById(refName)
      var top = element.offsetTop
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      })
    }
  }
}
</script>
